import LoadingComponent from '@/plugins/Loading/loading.vue';
var $vm;
var loadingPlugin = {
  install: function install(vue, options) {
    var Loading = vue.extend(LoadingComponent);

    var checkOrInit = function checkOrInit() {
      if (!$vm) {
        $vm = new Loading({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
    };

    var loading = {
      show: function show() {
        checkOrInit();
        $vm.loading = true;
      },
      hide: function hide() {
        if ($vm) {
          $vm.loading = false;
        }
      }
    };
    vue.$loading = loading;
    vue.prototype.$loading = loading;
    return loading;
  }
};
export default loadingPlugin;